import { Button } from '@imprivata-cloud/design-system';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { NonPurchasedProduct } from '../../../../api/types';
import HexPattern from '../../../../assets/product_card_pattern.svg?react';
import './UnpurchasedProductCard.less';

type UnpurchasedProductCardProps = { product: NonPurchasedProduct };

export const UnpurchasedProductCard = ({ product }: UnpurchasedProductCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={`marketing-card ${product.productTag}`}>
      <HexPattern className={'marketing-pattern'} aria-hidden />
      <h3 className={'marketing-title'}>{product.displayName}</h3>
      <Button
        variant="link"
        iconLeft={<ExternalLink aria-hidden="true" />}
        className={'marketing-link'}
        href={product.learnMoreUrl}
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        {t('portal.landing.learn-more')}
      </Button>
    </div>
  );
};
